import { ColorVariant } from '@/lib/colors';

export interface TabbedImageUploadProps {
  onUpload: (file: File) => Promise<string>;
  onClose: () => void;
  allowedTypes?: string[];
  maxSizeMB?: number;
  aspectRatio?: number;
  previewSize?: 'sm' | 'md' | 'lg';
  accentColor?: ColorVariant;
  onTabChange?: (tab: 'import' | 'generate' | 'upload') => void;
  showImportTab?: boolean;
  onDirectImageImport?: (imageUrl: string, altText?: string) => void; // UNIFIED: All imports use direct URL operations
}

export type AvatarStyleType = 'photo' | 'art' | 'anime' | '3d-render';

// Add the missing AvatarStyle interface
export interface AvatarStyle {
  id: AvatarStyleType;
  name: string;
  description?: string;
}

// Add the missing AvatarGenerationContentProps interface
export interface AvatarGenerationContentProps {
  aspectRatio?: number;
  setDescription?: (description: string) => void;
  setStyle?: (style: AvatarStyleType) => void;
}

// Add the AVATAR_STYLES constant
export const AVATAR_STYLES: Array<{ id: AvatarStyleType; name: string; iconId: string }> = [
  { id: 'photo', name: 'Photo', iconId: 'camera' },
  { id: 'art', name: 'Art', iconId: 'palette' },
  { id: 'anime', name: 'Anime', iconId: 'sparkles' },
  { id: '3d-render', name: '3D', iconId: 'box' }
];
